import React from 'react'
import { Facebook, GeoAltFill, Instagram, TelephoneFill } from 'react-bootstrap-icons'
import { Button, Col, div, Row } from 'reactstrap'
import ResponsiveHeader from './ResponsiveHeader'
import { Link } from 'react-router-dom'
// import ColumnIssue from './ColumnIssue'
// import ResponsiveHeader from './ResponsiveHeader'

const TopHeader = () => {
  return (
    <div id='website-responsive'  style={{ width:'', height:'', backgroundcolor:'', position:'', display:'fl', alignItems:'cen' }}>
        <div className='top-header-grid-cente py2 ps-md-4' style={{width:'', marginLeft:'1.5rm'}}>
    <div className='flex-cente'>
        {/* <ResponsiveHeader/> */}
           <Row className='flex-center5 me-md-2 display-none'>
          <Col sm='12' md='3' lg='3' className='flex-cente'>
        <div  className='flex-center5 me5'>
        <a href='tel: (800) 442-1663' style={{ textDecoration:'none' }}>
          <TelephoneFill className='text-ss-primary fs-ss-20'/>
        <text className='px-2 border- border2 me-md3 fw-600 text-montserrat fs-ss-18-2' style={{ color:'black', fontSize:'', }}> (800) 442-1663 </text>
        </a>
        </div>
        </Col>
        {/* <div className='flex-center1'>
        <a target='_blank' href='https://www.google.com/maps/place/Horizon+Medical+Clinic/@33.9702481,-86.4475894,15z/data=!4m5!3m4!1s0x0:0x15e2aaba8ae9ce07!8m2!3d33.9702938!4d-86.447629'>
          <GeoAltFill className='text-white'/>
        <text className='ps-2 text-white fs-ss-14-2 text-poppins' style={{ divor:'', fontSize:''}}>2343 2nd Ave E, Oneonta, AL 35121, US</text>
        </a>
        </div> */}

        {/* <div className='display-none1 flex-center ' style={{ width:'30%', display:'', justifyContent:'end', marginRight:'4.6rem',    }}>
          <a target='_blank' href='https://www.facebook.com/HorizonMedicalClinic/'><Facebook className='text-white fs-ss-22 me-3' /> </a>
          <a target='_blank' href='https://www.instagram.com/horizonmedicalclinic/'><Instagram className='text-white fs-ss-20' /></a>
        </div> */}

        <Col sm='12' md='9' lg='9' className='flex-cente display-none'>
        <Row className='' style={{ width:'', display:'flex', justifyContent:'space-around' }}>
                <Col sm='' md='4' lg='4' xl='' className='me3 ms4'>
                    <div className='flex-center10' style={{ width:''}}>
                        <Button className='btn-ss-secondary-header rounded20 mt-2 flex-center' style={{ backgroundColor:'#ea1f25',  boxShadow:'', display:'flex', width:'180px',  padding:''}}>
                            <Link to='/toxicology-test-appointment' className='text-montserrat fw-600 fs-ss-14 text-white' style={{ textDecoration:'none', padding:'',}}>
                                Book Toxicology Test
                            </Link>
                        </Button>
                    </div>
                </Col>  
                <Col sm='' md='4' lg='4' xl='' className='mx3 p-0'>
                    <div className='flex-center10'>
                        <Button className='btn-ss-secondary-header rounded20 mt-2 ' style={{  boxShadow:'', display:'flex', width:'160px', justifyContent:'center'}}>
                            <Link to='/general-blood-test-appointment' className='text-montserrat fw-600 fs-ss-14 text-white' style={{ padding:'', textDecoration:'none'}}>
                                Book Blood Test
                            </Link>
                        </Button>
                    </div>
                </Col>  
                <Col sm='' md='4' lg='4' xl='' className='mx3'>
                    <div className='flex-center10'>
                        <Button className='btn-ss-secondary-header rounded20 mt-2 ' style={{  boxShadow:'', display:'flex', width:'160px', justifyContent:'center'}}>
                            <Link to='/sti-std-test-appointment' className='text-montserrat fw-600 fs-ss-14 text-white' style={{ textDecoration:'none', padding:'',}}>
                                Book STI/HIV Test
                            </Link>
                        </Button>
                    </div>
                </Col>  
                <Col sm='' md='4' lg='6' xl='' className='mx3'>
                    <div className='flex-center10'>
                        <Button className='btn-ss-secondary-header rounded20 mt-2 ' style={{  boxShadow:'', display:'flex', width:'160px', justifyContent:'center'}}>
                            <Link to='/book-panel-test-appointment' className='text-montserrat fw-600 fs-ss-14 text-white' style={{ textDecoration:'none',padding:'',}}>
                                Book Panel Test
                            </Link>
                        </Button>
                    </div>
                </Col>  
                <Col sm='' md='4' lg='6' xl='' className='ms3 me0'>
                    <div className='flex-center-x'>
                        <Button className='btn-ss-secondary-header rounded20 mt-2 ' style={{  boxShadow:'', display:'flex', width:'160px', justifyContent:'center'}}>
                            <Link to='/book-covid-test-appointment' className='text-montserrat fw-600 fs-ss-14 text-white' style={{ textDecoration:'none',padding:'',}}>
                                Book Covid Test
                            </Link>
                        </Button>
                    </div>
                </Col>
                </Row>  
                </Col>
            </Row>
          <ResponsiveHeader/>

           
        </div>
        </div>
        </div>

  )
}

export default TopHeader